<template>
  <BootstrapModal class="EditWebsiteMenus"
    v-on="$listeners"
    :disable-button="!customPath && !selectedCategory"

    @save="saveProductGroup"
  >
    <div>
      <div class="d-flex tabs" :class="{editing}">
        <div class="tab-item" :class="{current: customPath}" @click="customPath = true">
          Custom path
        </div>
        <div class="tab-item" id="category-menu-tab" :class="{current: !customPath}" @click="customPath = false">
          Select Category
        </div>
      </div>

      <transition name="fade" mode="out-in">
        <div v-if="customPath" key="custom">
          <FormInput
            class="form-element"
            v-model="$v.name.$model"
      
            id="custom-name"
            label="Naam"
      
            :vuelidate="$v"
            fieldName="name"
          />
          <FormInput
            class="form-element"
            v-model="$v.path.$model"
      
            id="custom-path"
            label="Pad"
      
            :vuelidate="$v"
            fieldName="path"
          />
        </div>
        <div v-else key="category">
          <Categories
            :editable="false"
            :disable-router-redirects="true"
          >
            <template #header-title>
              <span></span>
            </template>

            <template #after-category="{item, isSubcategory}">
              <FormCustomRadio
                class="main-category-radio disable-ske"
                :class="{isSubcategory}"
                
                :value="item && item.uid === (selectedCategory && selectedCategory.uid)"
                @click.native="selectedCategory = item"
              />
            </template>
          </Categories>
        </div>
      </transition>
    </div>
  
    <template #title>
      {{ editing ? "Websitemenu toevoegen" : "Websitemenu bewerken" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import FormInput from "src/components/Inputs/FormInput.vue"
import Categories from "../../../pages/Categories.vue"
import FormCustomRadio from "../../../components/Inputs/FormCustomRadio.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: {
    callback: {
      type: Function,
      required: false,
    },
    menus: {
      type: Array,
      required: false,
    },
    websiteUid: {
      type: String,
      required: false,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  components: {
    FormCustomRadio,
    FormInput,
    BootstrapModal,
    Categories,
    FormCustomRadio,
  },
  validations: {
    name: {
      required,
    },
    path: {
      required,
    },
  },
  data() {
    return {
      name: "",
      path: "",

      customPath: true,
      editing: false,
      selectedCategory: null,
    }
  },
  created() {
    const index = this.index
    if (index || index === 0) {
      const item = this.menus[index]

      if (item) {
        this.editing = true

        if (item.category) {
          this.customPath = false
          this.selectedCategory = item
        } else {
          this.$v.name.$model = item.name
          this.$v.path.$model = item.path
          this.customPath = true
        }
      }
    }
  },
  methods: {
    saveProductGroup() {
      const customPath = this.customPath
      const category = this.selectedCategory
      
      if (customPath) {
        this.$v.$touch()
        if (this.$v.$error) return;
      } else if (!category) return;
      
      const obj = this.customPath ? {
        name: this.$v.name.$model,
        path: this.$v.path.$model,
      } : {
        category: category.uid,
      }

      let menus = (this.menus && this.menus.slice()) || []
      const index = this.index

      if (index || index === 0) {
        menus[index] = {
          ...obj,
          position: menus[index].position,
        }
      } else {
        menus.push({
          ...obj,
          position: menus.length,
        })
      }

      menus = menus.map(item => item.category ? {category: item.uid || item.category} : item)

      this.$handlePromise(async () => {
        await this.axios.put(`/api/websites/${this.websiteUid}`, {
          menu_items: menus,
        })

        this.callback && await this.callback()
        this.$emit("close")
        this.$success("Menu-item succesvol opgeslagen")
      })
    },
  },
  watch: {
    customPath() {
      if (!this.editing) this.selectedCategory = null
    },
  },
}

</script>

<style>

.EditWebsiteMenus .header-wrapper {
  padding: 0px !important;
}

</style>

<style scoped>

.EditWebsiteMenus {
  flex-basis: 500px;
}

.editing {
  pointer-events: none;
  opacity: .4;
}

.main-category-radio {
  position: absolute;
  top: 0;
  right: 25px;
  width: 25px;
  height: 30px;
  margin-top: 4px;
  cursor: pointer !important;
}

.main-category-radio.isSubcategory {
  margin-top: -1px;
}

.tabs {
  margin-bottom: 12px;
}

.tab-item {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  padding: 6px 0;
  font-size: 0.9375em;
  border-bottom: 1px solid #E3E3E3;
  cursor: pointer;
  transition-duration: .2s;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.tab-item:hover {
  background-color: rgba(50, 202, 210, .08);
}

.tab-item.current {
  color: #0081c7;
  border-bottom: 1px solid #0081c7; 
}

</style>
